var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('Address')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 box-header"},[_c('span',{staticClass:"name-page"},[_vm._v("แก้ไขที่อยู่จัดส่ง")])])])
}]

export { render, staticRenderFns }